import classNames from 'classnames';
import FJResourceItemLoading from '../../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import styles from './FJCreationEditStatusBox.module.less';
import PropTypes from 'prop-types';
import { useRef, useCallback, useEffect, useState } from 'react';
import FJConstant from '../../../../constants/FJConstant';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import { useMemo } from 'react';
import FJAppConstant from '../../../../constants/FJAppConstant';
import FJConfig from '../../../../config/FJConfig';
import ReloadIcon from '../../../../assets/svg/reload.svg?react';

const FJCreationEditLoadBox = props => {
    const {
        width,
        height,
        className,
        isShow,
        taskStatus,
        onRetry,
        initImagePadding,
        offsetTop,
        editImageLoadedStatus,
        onRefresh,
    } = props;

    const [sizeStyle, setSizeStyle] = useState({});
    const panelRef = useRef(null);

    const updateLoadingBoxStyle = useCallback(() => {
        if (!isShow) return {};

        if (panelRef.current) {
            const { clientWidth, clientHeight } = panelRef.current;

            if (!width || !height) {
                setSizeStyle({ width: clientWidth, height: clientHeight });
                return;
            }

            const aspectRatio = width / height;
            let newWidth = clientWidth;
            let newHeight = clientHeight;

            if (clientWidth / clientHeight > aspectRatio) {
                newWidth = clientHeight * aspectRatio;
            } else {
                newHeight = clientWidth / aspectRatio;
            }

            setSizeStyle({
                width: newWidth,
                height: newHeight,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width, height, isShow, initImagePadding, offsetTop]);

    useEffect(() => {
        updateLoadingBoxStyle();

        window.addEventListener('resize', updateLoadingBoxStyle);
        return () => {
            window.removeEventListener('resize', updateLoadingBoxStyle);
        };
    }, [updateLoadingBoxStyle]);

    const renderErrorBox = useMemo(() => {
        if (FJConfig.appType === FJAppConstant.PHOTO_RESTORATION || FJConfig.appType === FJAppConstant.PHOTO_COLORIZE) {
            return (
                <div style={sizeStyle} className={styles.error_box_old}>
                    <FJButton
                        type={FJButtonType.WHITE}
                        className={styles.retry_btn}
                        onClick={onRetry}
                        text={FJLocalStore._('retry')}
                        textClassName={styles.retry_btn_text}
                    />
                </div>
            );
        }

        return (
            <div style={sizeStyle} className={styles.error_box}>
                {FJLocalStore._('unknown-error-please-try-again')}

                <FJButton
                    type={FJButtonType.WHITE}
                    className={styles.retry_btn}
                    onClick={onRetry}
                    text={FJLocalStore._('retry')}
                    textClassName={styles.retry_btn_text}
                />
            </div>
        );
    }, [sizeStyle, onRetry]);

    return (
        <div
            ref={panelRef}
            className={classNames(styles.panel, className, { [styles.not_show]: !isShow })}
            style={{
                width: `calc(100% - ${initImagePadding.width}px)`,
                height: `calc(100% - ${initImagePadding.height}px)`,
                marginTop: offsetTop + initImagePadding.height / 2,
            }}
        >
            {(taskStatus === FJConstant.LOADING ||
                taskStatus === FJConstant.DEFAULT ||
                taskStatus === FJConstant.START ||
                taskStatus === FJConstant.GENERATING) &&
                !(editImageLoadedStatus === FJConstant.ERROR && taskStatus === FJConstant.DEFAULT) && (
                    <FJResourceItemLoading style={sizeStyle} className={styles.loading_box} />
                )}
            {taskStatus === FJConstant.ERROR && renderErrorBox}

            {editImageLoadedStatus === FJConstant.ERROR && taskStatus === FJConstant.DEFAULT && (
                <div style={sizeStyle} className={styles.edit_image_error_box} onClick={onRefresh}>
                    <ReloadIcon />
                </div>
            )}
        </div>
    );
};

FJCreationEditLoadBox.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    isShow: PropTypes.bool,
    taskStatus: PropTypes.string,
    onRetry: PropTypes.func,
    initImagePadding: PropTypes.object,
    offsetTop: PropTypes.number,
    editImageLoadedStatus: PropTypes.string,
    onRefresh: PropTypes.func,
};

export default FJCreationEditLoadBox;
